import {
  M8StatementDTO,
  M8StatementDTOSortableField,
  M8PagedResponse,
  M8PaginationParams,
} from 'services/production/types';
import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = M8PaginationParams<M8StatementDTOSortableField>;

export const getStatements = async (
  params: Params
): Promise<null | M8PagedResponse<M8StatementDTO>> => {
  const response = await customFetch(
    getM8AdminURL(`getStatements?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
